import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { gmToolNew, pickerOption, gmToolNewPage } from "@/mixins/index";
import { broadWhiteList, broadMake } from "@/api/gmToolNew/gmToolNew";
import addWhiteAccount from "./component/addWhiteAccount.vue";
export default {
  name: "anchorWhitelistAccount",
  mixins: [gmToolNew, pickerOption, gmToolNewPage],
  components: {
    addWhiteAccount: addWhiteAccount
  },
  data: function data() {
    return {
      reqLoading: false,
      exreqLoading: false,
      tableData: [] // 表格数据

    };
  },
  created: function created() {},
  methods: {
    getList: function getList(e) {
      var _this = this;

      this.reqLoading = true;
      broadWhiteList(_objectSpread({}, this.paramsData)).then(function (res) {
        if (res.status == 200) {
          _this.tableData = res.data;
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    // 删除配置
    handleDelete: function handleDelete(row) {
      var _this2 = this;

      this.$confirm(this.$t('confirmDeleteAnchorWhitelist'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                broadMake({
                  ver: 0,
                  user: row.user,
                  env_id: _this2.paramsData.env_id
                }).then(function (res) {
                  if (res.status == 200) {
                    _this2.getList();

                    _this2.$message({
                      type: "success",
                      message: _this2.$t('deleteSuccess')
                    });
                  }
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};